export default __webpack_public_path__ + "static/media/sofaportrait.c553495b.jpg";